import { useCallback, useContext, useMemo } from 'react';
import { BasketService } from '../services';
import { Basket } from '../types';
import { useQuery } from '@shared/modules/use-query/hooks';
import { MeContext } from '@modules/me/context/context';

export const useBaskets = (query?: any) => {
  const { state: userState } = useContext(MeContext);

  return useQuery<Basket[]>(
    useCallback(async () => {
      const result = await BasketService.getAll({ page: 1, per_page: 500, ...query });

      if (result.status === 200) {
        return result.data;
      } else {
        throw new Error(result.data);
      }
    }, [query]),
    useMemo(() => ({ initialData: [], enabled: !!userState.user.data }), [userState.user.data]),
  );
};
